export const bannersData = {
  data() {
    return {
      styleName: "tools-shop",
      bannerList: [
        {
          image: "https://faliznet.ir/assets/img/defualts/banner-4.jpg",
          style: "defualts",
        },
        {
          image: "https://faliznet.ir/assets/img/agriculture/banner-2.jfif",
          style: "agriculture",
        },
        {
          image: "https://faliznet.ir/assets/img/agriculture/banner-3.avif",
          style: "agriculture",
        },
        {
          image: "https://faliznet.ir/assets/img/agriculture/banner-4.jfif",
          style: "agriculture",
        },
        {
          image: "https://faliznet.ir/assets/img/furniture/banner-2.jfif",
          style: "furniture",
        },
        {
          image: "https://faliznet.ir/assets/img/furniture/banner-3.jfif",
          style: "furniture",
        },
        {
          image: "https://faliznet.ir/assets/img/photography/banner-2.jpg",
          style: "photography",
        },
        {
          image: "https://faliznet.ir/assets/img/photography/banner-3.jpg",
          style: "photography",
        },
        {
          image: "https://faliznet.ir/assets/img/photography/banner-4.jpg",
          style: "photography",
        },
        {
          image: "https://faliznet.ir/assets/img/esteghlal/banner-2.jpg",
          style: "esteghlal",
        },
        {
          image: "https://faliznet.ir/assets/img/esteghlal/banner-3.jpg",
          style: "esteghlal",
        },
        {
          image: "https://faliznet.ir/assets/img/esteghlal/banner-4.jpg",
          style: "esteghlal",
        },
        {
          image:
            "https://fa.shafaqna.com/media/2019/06/%D9%BE%D8%B1%D8%B3%D9%BE%D9%88%D9%84%DB%8C%D8%B3.jpg",
          style: "persepolis",
        },
        {
          image:
            "https://image.footballi.app/@s/news/images/20190913/15683656049307.jpg",
          style: "persepolis",
        },
        {
          image:
            "https://static3.mojnews.com/thumbnail/DBWxHCOINuy1/b3KyLJtobNa7mxZapfED8JOntVHTpFuUbWspqcFByNkcHNRUCrFsz0kM90mnzV49H9KandiKg2ugPzrLJCrgItJiXOW4ZQ_IYsHoagkScps,/%D8%AC%D8%B4%D9%86+%D9%82%D9%87%D8%B1%D9%85%D8%A7%D9%86%DB%8C+%D9%BE%D8%B1%D8%B3%D9%BE%D9%88%D9%84%DB%8C%D8%B3+%D8%AF%D8%B1+%D8%B3%D9%88%D9%BE%D8%B1%D8%AC%D8%A7%D9%85.jpg",
          style: "persepolis",
        },
        {
          image: "https://faliznet.ir/assets/img/moharram/banner-2.jpg",
          style: "moharram",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/tomato/banner(1).jpg",
          style: "agriculture agriculture_tomato",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/tomato/banner(2).jpg",
          style: "agriculture agriculture_tomato",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/tomato/banner(3).jpg",
          style: "agriculture agriculture_tomato",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/eggplant/banner(1).jpg",
          style: "agriculture agriculture_eggplant",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/eggplant/banner(2).jpg",
          style: "agriculture agriculture_eggplant",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/eggplant/banner(3).jpg",
          style: "agriculture agriculture_eggplant",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/cucumber2/banner(1).jpg",
          style: "agriculture agriculture_cucumber2",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/cucumber2/banner(2).jpg",
          style: "agriculture agriculture_cucumber2",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/cucumber2/banner(3).jpg",
          style: "agriculture agriculture_cucumber2",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/cucumber/banner(1).jpg",
          style: "agriculture agriculture_cucumber",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/cucumber/banner(2).jpg",
          style: "agriculture agriculture_cucumber",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/cucumber/banner(3).jpg",
          style: "agriculture agriculture_cucumber",
        },

        {
          image:
            "https://faliznet.ir/assets/img/agriculture/strawberry/banner(1).jpg",
          style: "agriculture agriculture_strawberry",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/strawberry/banner(2).jpg",
          style: "agriculture agriculture_strawberry",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/strawberry/banner(3).jpg",
          style: "agriculture agriculture_strawberry",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/sweet-pepper-red/banner(1).jpg",
          style: "agriculture agriculture_sweet-pepper-red",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/sweet-pepper-red/banner(2).jpg",
          style: "agriculture agriculture_sweet-pepper-red",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/sweet-pepper-red/banner(3).jpg",
          style: "agriculture agriculture_sweet-pepper-red",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/sweet-pepper-yellow/banner(1).jpg",
          style: "agriculture agriculture_sweet-pepper-yellow",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/sweet-pepper-yellow/banner(2).jpg",
          style: "agriculture agriculture_sweet-pepper-yellow",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/sweet-pepper-yellow/banner(3).jpg",
          style: "agriculture agriculture_sweet-pepper-yellow",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/sweet-pepper-yellow/banner(4).jpg",
          style: "agriculture agriculture_sweet-pepper-yellow",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/sweet-pepper-green/banner(1).jpg",
          style: "agriculture agriculture_sweet-pepper-green",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/sweet-pepper-green/banner(2).jpg",
          style: "agriculture agriculture_sweet-pepper-green",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/sweet-pepper-green/banner(3).jpg",
          style: "agriculture agriculture_sweet-pepper-green",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/orange/banner(1).jpg",
          style: "agriculture agriculture_orange",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/orange/banner(2).jpg",
          style: "agriculture agriculture_orange",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/orange/banner(3).jpg",
          style: "agriculture agriculture_orange",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/orange-red/banner(1).jpg",
          style: "agriculture agriculture_orange-red",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/orange-red/banner(2).jpg",
          style: "agriculture agriculture_orange-red",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/orange-red/banner(3).jpg",
          style: "agriculture agriculture_orange-red",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/sour-lemon/banner(1).jpg",
          style: "agriculture agriculture_sour-lemon",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/sour-lemon/banner(2).jpg",
          style: "agriculture agriculture_sour-lemon",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/sour-lemon/banner(3).jpg",
          style: "agriculture agriculture_sour-lemon",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/lemon/banner(1).jpg",
          style: "agriculture agriculture_lemon",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/lemon/banner(2).jpg",
          style: "agriculture agriculture_lemon",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/lemon/banner(3).jpg",
          style: "agriculture agriculture_lemon",
        },
        {
          image: "https://faliznet.ir/assets/img/agriculture/rose/banner(1).jpg",
          style: "agriculture agriculture_rose",
        },
        {
          image: "https://faliznet.ir/assets/img/agriculture/rose/banner(2).jpg",
          style: "agriculture agriculture_rose",
        },
        {
          image: "https://faliznet.ir/assets/img/agriculture/rose/banner(3).jpg",
          style: "agriculture agriculture_rose",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/onion/banner(1).jpg",
          style: "agriculture agriculture_onion",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/onion/banner(2).jpg",
          style: "agriculture agriculture_onion",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/onion/banner(3).jpg",
          style: "agriculture agriculture_onion",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/potato/banner(1).jpg",
          style: "agriculture agriculture_potato",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/potato/banner(2).jpg",
          style: "agriculture agriculture_potato",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/potato/banner(3).jpg",
          style: "agriculture agriculture_potato",
        },

        {
          image:
            "https://faliznet.ir/assets/img/agriculture/green-beans/banner(1).jpg",
          style: "agriculture agriculture_green-beans",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/green-beans/banner(2).jpg",
          style: "agriculture agriculture_green-beans",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/green-beans/banner(3).jpg",
          style: "agriculture agriculture_green-beans",
        },

        {
          image: "https://faliznet.ir/assets/img/agriculture/soy/banner(1).jpg",
          style: "agriculture agriculture_soy",
        },
        {
          image: "https://faliznet.ir/assets/img/agriculture/soy/banner(2).jpg",
          style: "agriculture agriculture_soy",
        },
        {
          image: "https://faliznet.ir/assets/img/agriculture/soy/banner(3).jpg",
          style: "agriculture agriculture_soy",
        },

        {
          image:
            "https://faliznet.ir/assets/img/agriculture/red-beans/banner(1).jpg",
          style: "agriculture agriculture_red-beans",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/red-beans/banner(2).jpg",
          style: "agriculture agriculture_red-beans",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/red-beans/banner(3).jpg",
          style: "agriculture agriculture_red-beans",
        },

        {
          image:
            "https://faliznet.ir/assets/img/agriculture/chickpeas/banner(1).jpg",
          style: "agriculture agriculture_chickpeas",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/chickpeas/banner(2).jpg",
          style: "agriculture agriculture_chickpeas",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/chickpeas/banner(3).jpg",
          style: "agriculture agriculture_chickpeas",
        },

        {
          image:
            "https://faliznet.ir/assets/img/agriculture/lentils/banner(1).jpg",
          style: "agriculture agriculture_lentils",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/lentils/banner(2).jpg",
          style: "agriculture agriculture_lentils",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/lentils/banner(3).jpg",
          style: "agriculture agriculture_lentils",
        },

        {
          image:
            "https://faliznet.ir/assets/img/agriculture/green-squash/banner(1).jpg",
          style: "agriculture agriculture_green-squash",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/green-squash/banner(2).jpg",
          style: "agriculture agriculture_green-squash",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/green-squash/banner(3).jpg",
          style: "agriculture agriculture_green-squash",
        },

        {
          image:
            "https://faliznet.ir/assets/img/agriculture/cantaloupe/banner(1).jpg",
          style: "agriculture agriculture_cantaloupe",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/cantaloupe/banner(2).jpg",
          style: "agriculture agriculture_cantaloupe",
        },
        {
          image:
            "https://faliznet.ir/assets/img/agriculture/cantaloupe/banner(3).jpg",
          style: "agriculture agriculture_cantaloupe",
        },

        {
          image: "https://faliznet.ir/assets/img/fastfood/banner(1).jpg",
          style: "fastfood",
        },
        {
          image: "https://faliznet.ir/assets/img/fastfood/banner(2).jpg",
          style: "fastfood",
        },
        {
          image: "https://faliznet.ir/assets/img/fastfood/banner(3).jpg",
          style: "fastfood",
        },

        {
          image: "https://faliznet.ir/assets/img/coffeshop/banner(1).jpg",
          style: "coffeshop",
        },
        {
          image: "https://faliznet.ir/assets/img/coffeshop/banner(2).jpg",
          style: "coffeshop",
        },
        {
          image: "https://faliznet.ir/assets/img/coffeshop/banner(3).jpg",
          style: "coffeshop",
        },

        {
          image: "https://faliznet.ir/assets/img/juiceshop/banner(1).jpg",
          style: "juiceshop",
        },
        {
          image: "https://faliznet.ir/assets/img/juiceshop/banner(2).jpg",
          style: "juiceshop",
        },
        {
          image: "https://faliznet.ir/assets/img/juiceshop/banner(3).jpg",
          style: "juiceshop",
        },

        {
          image: "https://faliznet.ir/assets/img/restaurant/banner(1).jpg",
          style: "restaurant",
        },
        {
          image: "https://faliznet.ir/assets/img/restaurant/banner(2).jpg",
          style: "restaurant",
        },
        {
          image: "https://faliznet.ir/assets/img/restaurant/banner(3).jpg",
          style: "restaurant",
        },
      ],
    };
  },
  methods: {
    getbanners(styleName, galery) {
      if (galery) {
        if (galery.includes(",")) {
          var galeries = galery.split(",");
          return galeries;
        }
        return galery;
      } else {
        return this.bannerList.filter((el) => el.style == styleName);
      }
    },
  },
};
